import React from 'react'
import MUIDataTable from 'mui-datatables'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { lightTheme } from 'config/theme'
import { deepmerge } from '@mui/utils'

const BasicTable = ({ data, columns, options }) => {
  const getMuiTheme = () =>
    createTheme(
      deepmerge(lightTheme, {
        overrides: {
          MuiButton: {
            root: {
              fontWeight: 'bold'
            }
          },
          MUIDataTableHeadCell: {
            root: {
              fontWeight: 'bold'
            }
          },
          MUIDataTableBodyCell: { root: { color: 'inherit' } },
          MuiTableCell: { root: { padding: '14px' } }
        }
      })
    )

  return (
    <ThemeProvider theme={getMuiTheme}>
      <MUIDataTable data={data} columns={columns} options={options} />
    </ThemeProvider>
  )
}

export default BasicTable
